// Icon configuration for offline/online usage
import palette from '../theme/palette';

// Color constants from palette
const PRIMARY_COLOR = palette.light.primary.main; // '#00AB55'
const SECONDARY_COLOR = palette.light.secondary.main; // '#3366FF'
const INFO_COLOR = palette.light.info.main; // '#1890FF'
const SUCCESS_COLOR = palette.light.success.main; // '#54D62C'
const WARNING_COLOR = palette.light.warning.main; // '#FFC107'
const ERROR_COLOR = palette.light.error.main; // '#FF4842'

export const ICON_CONFIG = {
  // Local icons mapping (original local icons)
  localIcons: {
    'ic-suggestion': '/icons/ic_suggestion.svg',
    'ic-dashboard': '/icons/ic_dashboard.svg',
    'ic-user': '/icons/ic_user.svg',
    'ic-funds': '/icons/ic_funds.svg',
    'ic-documents': '/icons/ic_documents.svg',
    'ic-notification-chat': '/icons/ic_notification_chat.svg',
    'ic-notification-settings': '/icons/ic_notification_settings.svg',
    'ic-tiles-settings': '/icons/ic_tiles_settings.svg',
    'ic-usb-drive': '/icons/ic_usb_drive.svg',
    'ic-users-setting': '/icons/ic_users_setting.svg',
    'ic-account-payment': '/icons/Ic_account-payment.svg',
    'ic-bill-list': '/icons/ic_bill_list.svg',
    'ic-report-search': '/icons/ic_report-search.svg',
    'ic-deptors-reports': '/icons/ic-deptors-reports.svg',
    'ic-flag-en': '/icons/ic_flag_en.svg',
    'img-placeholder': '/icons/img_placeholder.svg',

    // Downloaded Eva Icons
    'eva-close-fill': '/icons/eva-close-fill.svg',
    'eva-search-fill': '/icons/eva-search-fill.svg',
    'eva-bell-fill': '/icons/eva-bell-fill.svg',
    'eva-menu-2-fill': '/icons/eva-menu-2-fill.svg',
    'eva-eye-fill': '/icons/eva-eye-fill.svg',
    'eva-eye-off-fill': '/icons/eva-eye-off-fill.svg',
    'eva-home-fill': '/icons/eva-home-fill.svg',
    'eva-file-fill': '/icons/eva-file-fill.svg',
    'eva-book-open-fill': '/icons/eva-book-open-fill.svg',
    'eva-arrow-ios-back-fill': '/icons/eva-arrow-ios-back-fill.svg',
    'eva-arrow-ios-downward-fill': '/icons/eva-arrow-ios-downward-fill.svg',
    'eva-arrow-ios-forward-fill': '/icons/eva-arrow-ios-forward-fill.svg',
    'eva-arrow-ios-upward-fill': '/icons/eva-arrow-ios-upward-fill.svg',
    'eva-done-all-fill': '/icons/eva-done-all-fill.svg',
    'eva-clock-outline': '/icons/eva-clock-outline.svg',
    'eva-sync-outline': '/icons/eva-sync-outline.svg',
    'eva-trash-outline': '/icons/eva-trash-outline.svg',
    'eva-info-fill': '/icons/eva-info-fill.svg',
    'eva-checkmark-circle-2-fill': '/icons/eva-checkmark-circle-2-fill.svg',
    'eva-alert-triangle-fill': '/icons/eva-alert-triangle-fill.svg',
    'eva-alert-circle-fill': '/icons/eva-alert-circle-fill.svg',
    'eva-google-fill': '/icons/eva-google-fill.svg',
    'eva-facebook-fill': '/icons/eva-facebook-fill.svg',
    'eva-twitter-fill': '/icons/eva-twitter-fill.svg',

    // Downloaded Material Design Icons
    'ic-round-add-a-photo': '/icons/ic-round-add-a-photo.svg',
    'ic-round-account-box': '/icons/ic-round-account-box.svg',
    'ic-round-vpn-key': '/icons/ic-round-vpn-key.svg',
    'ic-round-undo': '/icons/ic-round-undo.svg',
    'ic-round-redo': '/icons/ic-round-redo.svg',

    // Downloaded Line MD Icons
    'line-md-downloading-loop': '/icons/line-md-downloading-loop.svg',
    'line-md-download-loop': '/icons/line-md-download-loop.svg',
    'line-md-upload-loop': '/icons/line-md-upload-loop.svg',
    'line-md-loading-loop': '/icons/line-md-loading-loop.svg',
    'line-md-list-3': '/icons/line-md-list-3.svg',
    'line-md-edit': '/icons/line-md-edit.svg',

    // Downloaded Material Symbols
    'material-symbols-light-search': '/icons/material-symbols-light-search.svg',
    'material-symbols-light-delete-outline': '/icons/material-symbols-light-delete-outline.svg',
    'material-symbols-light-close': '/icons/material-symbols-light-close.svg',
    'material-symbols-light-delete-sweep-outline': '/icons/material-symbols-light-delete-sweep-outline.svg',
    'material-symbols-sync-alt': '/icons/material-symbols-sync-alt.svg',

    // Downloaded Solar Icons
    'solar-user-bold-duotone': '/icons/solar-user-bold-duotone.svg',

    // Downloaded Majesticons
    'majesticons-close': '/icons/majesticons-close.svg',

    // Downloaded Lucide Icons
    'lucide-copy-check': '/icons/lucide-copy-check.svg',
    'lucide-copy': '/icons/lucide-copy.svg',

    // Downloaded Phosphor Icons
    'ph-sun-duotone': '/icons/ph-sun-duotone.svg',
    'ph-moon-duotone': '/icons/ph-moon-duotone.svg',

    // Downloaded Fluent MDL2
    'fluent-mdl2-document-management': '/icons/fluent-mdl2-document-management.svg',
    'fluent-mdl2-view': '/icons/fluent-mdl2-view.svg',

    // Downloaded System UIcons
    'system-uicons-user-add': '/icons/system-uicons-user-add.svg',
    'system-uicons-user-remove': '/icons/system-uicons-user-remove.svg',

    // Downloaded Vaadin Icons
    'vaadin-dot-circle': '/icons/vaadin-dot-circle.svg',

    // Downloaded Teenyicons
    'teenyicons-attachment-solid': '/icons/teenyicons-attachment-solid.svg',

    // Downloaded Icon Park Outline
    'icon-park-outline-funds': '/icons/icon-park-outline-funds.svg',
    'icon-park-outline-history': '/icons/icon-park-outline-history.svg',

    // Downloaded Additional Icons
    'mdi-home': '/icons/mdi-home.svg',
    'mdi-account': '/icons/mdi-account.svg',
    'mdi-settings': '/icons/mdi-settings.svg',
    'mdi-logout': '/icons/mdi-logout.svg',
    'feather-home': '/icons/feather-home.svg',
    'feather-user': '/icons/feather-user.svg',
    'feather-settings': '/icons/feather-settings.svg',
    'heroicons-home': '/icons/heroicons-home.svg',
    'heroicons-user': '/icons/heroicons-user.svg',
    'heroicons-cog': '/icons/heroicons-cog.svg',
  },

  // Settings
  settings: {
    // Enable/disable online fallback
    enableOnlineFallback: true,
    // Cache online icons locally
    cacheOnlineIcons: true,
    // Default icon size
    defaultSize: '1em',
    // Default color
    defaultColor: 'inherit',
  },
};

// Helper functions
export const isLocalIcon = (iconName) => {
  // Convert icon names from colon format to dash format
  const convertedName = iconName.replace(/:/g, '-');
  return convertedName in ICON_CONFIG.localIcons;
};

export const getLocalIconPath = (iconName) => {
  // Convert icon names from colon format to dash format
  const convertedName = iconName.replace(/:/g, '-');
  return ICON_CONFIG.localIcons[convertedName];
};

export const shouldUseOnlineFallback = () => {
  return ICON_CONFIG.settings.enableOnlineFallback;
};

// Function to convert hex color to CSS filter
const hexToFilter = (hexColor) => {
  // Remove # if present
  const hex = hexColor.replace('#', '');

  // Convert hex to RGB
  const r = parseInt(hex.substr(0, 2), 16);
  const g = parseInt(hex.substr(2, 2), 16);
  const b = parseInt(hex.substr(4, 2), 16);

  // Calculate filter values
  const brightness = (r * 299 + g * 587 + b * 114) / 1000;
  const saturation = Math.max(r, g, b) - Math.min(r, g, b);

  // Create filter string
  return `brightness(0) saturate(100%) invert(${(brightness / 255) * 100}%) sepia(${
    (saturation / 255) * 100
  }%) saturate(${saturation * 10}%) hue-rotate(${(Math.atan2(b - g, r - g) * 180) / Math.PI}deg) brightness(${
    (brightness / 255) * 100
  }%) contrast(${(brightness / 255) * 100}%)`;
};

// تابع جدید برای گرفتن رنگ از theme جاری
export const getColorFilter = (color, theme) => {
  if (!theme) return 'none';
  const palette = theme.palette;

  // پشتیبانی از کلیدهای palette مثل 'primary', 'secondary', ...
  let hex = palette[color]?.main;
  // پشتیبانی از رنگ‌های متنی
  if (!hex && color.startsWith('text.')) {
    const key = color.split('.')[1];
    hex = palette.text[key];
  }
  // اگر رنگ پیدا نشد، هیچ فیلتری اعمال نشود
  if (!hex) return 'none';

  // تبدیل hex به فیلتر (می‌توانید همان hexToFilter قبلی را استفاده کنید)
  return hexToFilter(hex);
};

// Function to get color filter with theme support
export const getColorFilterWithTheme = (color, themeMode = 'light') => {
  return getColorFilter(color, themeMode);
};
